import(/* webpackMode: "eager", webpackExports: ["StatusPage"] */ "/home/nexts/lm-master-front/src/flat-pages/status/index.tsx");
